import React from 'react';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import PropTypes from 'prop-types';
import IconButton from 'components/common/IconButton';

const ExportToXLSX = ({ data, fileName }) => {
  const exportToExcel = () => {
    const wsTreePlanting = XLSX.utils.json_to_sheet(data['treePlanting']);
    const wsWindTurbine = XLSX.utils.json_to_sheet(data['windTurbine']);
    const wsSolarPanel = XLSX.utils.json_to_sheet(data['solarPanel']);

    const workbook = XLSX.utils.book_new();
    // Define styles
    const headerStyle = {
      font: { bold: true, color: 'FFFFFF' },
      fill: { fgColor: '4CAF50', patternType: 'solid' },
      border: {
        top: { style: 'thin' },
        bottom: { style: 'thin' },
        left: { style: 'thin' },
        right: { style: 'thin' }
      },
      alignment: { horizontal: 'center', vertical: 'center', wrapText: true }
    };

    // Apply header styles
    for (let col = 0; col < data['treePlanting'][0].length; col++) {
      const headerCell = XLSX.utils.encode_cell({ r: 0, c: col });
      wsTreePlanting[headerCell].s = headerStyle;
    }
    for (let col = 0; col < data['windTurbine'][0].length; col++) {
      const headerCell = XLSX.utils.encode_cell({ r: 0, c: col });
      wsWindTurbine[headerCell].s = headerStyle;
    }
    for (let col = 0; col < data['solarPanel'][0].length; col++) {
      const headerCell = XLSX.utils.encode_cell({ r: 0, c: col });
      wsSolarPanel[headerCell].s = headerStyle;
    }

    XLSX.utils.book_append_sheet(
      workbook,
      wsTreePlanting,
      'Tree Planting Evaluation'
    );
    XLSX.utils.book_append_sheet(
      workbook,
      wsWindTurbine,
      'Wind Turbine Evaluation'
    );
    XLSX.utils.book_append_sheet(
      workbook,
      wsSolarPanel,
      'Solar Panel Evaluation'
    );

    const excelBuffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array'
    });
    const newData = new Blob([excelBuffer], {
      type: 'application/octet-stream'
    });
    saveAs(newData, `${fileName}.xlsx`);
  };

  return (
    <IconButton
      // className="my-3"
      icon="download"
      onClick={exportToExcel}
    >
      Export
    </IconButton>
  );
};

ExportToXLSX.propTypes = {
  data: PropTypes.array.isRequired,
  fileName: PropTypes.string.isRequired,
  sheetName: PropTypes.string.isRequired
};
export default ExportToXLSX;
